/**
 * User-configurable game settings, persisted to localStorage.
 *
 * Loaded on startup by `settingsManager.loadSettings()` and saved
 * whenever the user changes a setting through the menu.
 */
export interface GameSettings {
    /** Cards drawn per stock tap: 1 (easy) or 3 (classic). */
    drawCount: 1 | 3
    /** Key into the `themes` object identifying the active visual theme. */
    themeName: string
    /** Layout orientation — mirrors the board for left-handed players. */
    handedness: 'left' | 'right'
    /** Card back style: decorative pattern or flat color from the theme. */
    cardBackDesign: 'pattern' | 'solid'
    /** Auto-flip the top face-down card when a tableau column is exposed. */
    autoFlipCards: boolean
    /** Taptic Engine feedback on card lift/drop (iOS/Android). */
    hapticsEnabled: boolean
    /** Play sound effects on card actions. */
    soundEnabled: boolean
    /** Enable card movement animations and transitions. */
    animationsEnabled: boolean
}

/** Sensible defaults for a new installation. */
export const defaultSettings: GameSettings = {
    drawCount: 1,
    themeName: 'HappyPurpleTheme',
    handedness: 'right',
    cardBackDesign: 'pattern',
    autoFlipCards: true,
    hapticsEnabled: true,
    soundEnabled: true,
    animationsEnabled: true,
}
